<template>
    <div class="form-layout login-screen">

        <div class="form-rows">
            <div class="fields input half" :class="{'has-error': errors.has('email') }">
                <label for="email">{{ locale.text_email_address_label }}</label>
                <input type="email" @keyup.enter="handle" v-validate="{ rules: { required: true } }" name="email" id="email" :placeholder="locale.text_email_address_label" v-model="email"/>
                <p class="text-danger" v-if="errors.has('email')">{{ errors.first('email') }}</p>
            </div>

            <div class="fields input half right" :class="{'has-error': errors.has('password') }">
                <label for="password">{{ locale.text_password_label }}</label>
                <input type="password" @keyup.enter="handle" v-validate="{ rules: { required: true } }" name="password" id="password" :placeholder="locale.text_password_label" v-model="password"/>
                <p class="text-danger" v-if="errors.has('password')">{{ errors.first('password') }}</p>
                <p  class="text-right"><router-link :to="{ name: 'auth.password', query: { email} }">{{ locale.text_forgotten_password }}</router-link></p>
            </div>
        </div>

        <div class="form-rows last">
            <div class="fields input half right login-button">
                <button type="button" class="cta-button blue loading" v-if="loading_icon" disabled><i class="fa fa-spinner fa-pulse"></i></button>
                <input type="button" @click="loading_icon = true; handle()" class="cta-button blue" v-else :value="locale.button_login">
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                email: "",
                password: "",

                loading_icon: false,
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.account.register;
            }
        },
        methods: {
            handle: function () {
                /**
                 * Obviously don't want to continue if there are errors.
                 */
                this.$validator.validateAll();
                if(this.errors.errors.length) {
                    $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                    this.loading_icon = false;
                    return false;
                }

                /**
                 * Submitting! :)
                 */
                axios.post('camp-booking/users/login', {
                    "email": this.email,
                    "password_clear": this.password
                }).then(response => {
                    this.$root.auth = response.data.data;
                    this.$root.alert(this.locale.text_alert_logged_in, 'success');
                    this.$emit('authenticated', response.data.data)
                }).catch(response => {					
                    this.$root.alert(this.locale.text_alert_wrong_details);
					this.loading_icon = false;
                    $("html, body").animate({ scrollTop: $(".title-bar").offset().top }, "slow");
                });
				

            }
        },
    }
</script>



// WEBPACK FOOTER //
// login.vue?62831cb6